import { FC, useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CreateLinkTo } from 'shared/constants/linkTo';
import { formatDate } from '../../../../../_ftbl/main/helpers/dateFormatting';
import { FtblPrediction } from './types';
import { ProfilePredictionFlag } from './ProfilePredictionFlag';
import {
  PredictionBadge,
  PredictionCard,
  PredictionCardClickIcon,
  PredictionCardHoverChampion,
  PredictionCardHoverDate,
  PredictionCardHoverOverlay,
  PredictionCardMeta,
  PredictionCardMetaBold,
  PredictionCardMetaChampion,
  PredictionCardMetaDate,
  PredictionCardMetaPrediction,
  PredictionCardWrapper,
  PredictionFlagSection,
  PredictionTopSection,
  TeamName,
  TeamRow,
  TeamsSection,
  TeamScore,
} from './styles';

type ProfilePredictionCardProps = {
  prediction: FtblPrediction;
};

const formatScore = (score: number | null) => (score === null ? '–' : score);

const getPredictedTeamName = (prediction: FtblPrediction) => {
  if (prediction.variant === 1) return prediction.homeTeam.name;
  if (prediction.variant === 2) return prediction.guestTeam.name;

  return null;
};

export const ProfilePredictionCard: FC<ProfilePredictionCardProps> = ({ prediction }) => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const { homeTeam, guestTeam, homeTeamScore, guestTeamScore, date, championship, gameScheduleId } = prediction;

  const predictedTeamName = useMemo(() => getPredictedTeamName(prediction), [prediction]);

  const badgeText = useMemo(() => {
    if (predictedTeamName) {
      return t('ftbl.profile_page.my_prediction_team', { team: predictedTeamName });
    }

    return t('ftbl.profile_page.my_prediction_draw');
  }, [predictedTeamName, t]);

  const formattedDate = useMemo(
    () => formatDate(date, i18n.language, 'datetime'),
    [date, i18n.language],
  );

  const handleClick = useCallback(() => {
    if (!gameScheduleId) return;

    history.push(CreateLinkTo.match(String(gameScheduleId)));
  }, [gameScheduleId, history]);

  return (
    <PredictionCardWrapper>
      <PredictionCard onClick={handleClick}>
        <PredictionTopSection>
          <ProfilePredictionFlag countryId={homeTeam.countryId} />
          <PredictionBadge>{badgeText}</PredictionBadge>
        </PredictionTopSection>
        <TeamsSection>
          <TeamRow>
            <TeamName>{homeTeam.name}</TeamName>
            <TeamScore>{formatScore(homeTeamScore)}</TeamScore>
          </TeamRow>
          <TeamRow>
            <TeamName>{guestTeam.name}</TeamName>
            <TeamScore>{formatScore(guestTeamScore)}</TeamScore>
          </TeamRow>
        </TeamsSection>
        <PredictionFlagSection>
          <ProfilePredictionFlag countryId={guestTeam.countryId} />
        </PredictionFlagSection>
        <PredictionCardHoverOverlay>
          <PredictionCardHoverDate>{formattedDate}</PredictionCardHoverDate>
          <PredictionCardHoverChampion>{championship.name}</PredictionCardHoverChampion>
        </PredictionCardHoverOverlay>
      </PredictionCard>
      <PredictionCardMeta>
        <PredictionCardMetaDate>{formattedDate}</PredictionCardMetaDate>
        <PredictionCardMetaChampion>{championship.name}</PredictionCardMetaChampion>
        <PredictionCardMetaPrediction>
          {predictedTeamName ? (
            <>
              {t('ftbl.profile_page.my_prediction_prefix')}{' '}
              <PredictionCardMetaBold>{predictedTeamName}</PredictionCardMetaBold>
            </>
          ) : (
            <>
              {t('ftbl.profile_page.my_prediction_prefix')}
              {i18n.language === 'ru' ? ': ' : ' '}
              <PredictionCardMetaBold>{t('ftbl.profile_page.my_prediction_draw_word')}</PredictionCardMetaBold>
            </>
          )}
        </PredictionCardMetaPrediction>
      </PredictionCardMeta>
    </PredictionCardWrapper>
  );
};
import { FC, useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CreateLinkTo } from 'shared/constants/linkTo';
import { formatDate } from '../../../../../_ftbl/main/helpers/dateFormatting';
import { FtblPrediction } from './types';
import { ProfilePredictionFlag } from './ProfilePredictionFlag';
import {
  PredictionBadge,
  PredictionCard,
  PredictionCardClickIcon,
  PredictionCardHoverChampion,
  PredictionCardHoverDate,
  PredictionCardHoverOverlay,
  PredictionCardMeta,
  PredictionCardMetaBold,
  PredictionCardMetaChampion,
  PredictionCardMetaDate,
  PredictionCardMetaPrediction,
  PredictionCardWrapper,
  PredictionFlagSection,
  PredictionTopSection,
  TeamName,
  TeamRow,
  TeamsSection,
  TeamScore,
} from './styles';

type ProfilePredictionCardProps = {
  prediction: FtblPrediction;
};

const formatScore = (score: number | null) => (score === null ? '–' : score);

const getPredictedTeamName = (prediction: FtblPrediction) => {
  if (prediction.variant === 1) return prediction.homeTeam.name;
  if (prediction.variant === 2) return prediction.guestTeam.name;

  return null;
};

export const ProfilePredictionCard: FC<ProfilePredictionCardProps> = ({ prediction }) => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const { homeTeam, guestTeam, homeTeamScore, guestTeamScore, date, championship, gameScheduleId } = prediction;

  const predictedTeamName = useMemo(() => getPredictedTeamName(prediction), [prediction]);

  const badgeText = useMemo(() => {
    if (predictedTeamName) {
      return t('ftbl.profile_page.my_prediction_team', { team: predictedTeamName });
    }

    return t('ftbl.profile_page.my_prediction_draw');
  }, [predictedTeamName, t]);

  const formattedDate = useMemo(
    () => formatDate(date, i18n.language, 'datetime'),
    [date, i18n.language],
  );

  const handleClick = useCallback(() => {
    if (!gameScheduleId) return;

    history.push(CreateLinkTo.match(String(gameScheduleId)));
  }, [gameScheduleId, history]);

  return (
    <PredictionCardWrapper>
      <PredictionCard onClick={handleClick}>
        <PredictionTopSection>
          <ProfilePredictionFlag countryId={homeTeam.countryId} />
          <PredictionBadge>{badgeText}</PredictionBadge>
        </PredictionTopSection>
        <TeamsSection>
          <TeamRow>
            <TeamName>{homeTeam.name}</TeamName>
            <TeamScore>{formatScore(homeTeamScore)}</TeamScore>
          </TeamRow>
          <TeamRow>
            <TeamName>{guestTeam.name}</TeamName>
            <TeamScore>{formatScore(guestTeamScore)}</TeamScore>
          </TeamRow>
        </TeamsSection>
        <PredictionFlagSection>
          <ProfilePredictionFlag countryId={guestTeam.countryId} />
        </PredictionFlagSection>
        <PredictionCardHoverOverlay>
          <PredictionCardHoverDate>{formattedDate}</PredictionCardHoverDate>
          <PredictionCardHoverChampion>{championship.name}</PredictionCardHoverChampion>
        </PredictionCardHoverOverlay>
      </PredictionCard>
      <PredictionCardMeta>
        <PredictionCardMetaDate>{formattedDate}</PredictionCardMetaDate>
        <PredictionCardMetaChampion>{championship.name}</PredictionCardMetaChampion>
        <PredictionCardMetaPrediction>
          {predictedTeamName ? (
            <>
              {t('ftbl.profile_page.my_prediction_prefix')}{' '}
              <PredictionCardMetaBold>{predictedTeamName}</PredictionCardMetaBold>
            </>
          ) : (
            <>
              {t('ftbl.profile_page.my_prediction_prefix')}
              {i18n.language === 'ru' ? ': ' : ' '}
              <PredictionCardMetaBold>{t('ftbl.profile_page.my_prediction_draw_word')}</PredictionCardMetaBold>
            </>
          )}
        </PredictionCardMetaPrediction>
      </PredictionCardMeta>
    </PredictionCardWrapper>
  );
};
